import { Link } from 'react-router-dom'

export default function SiteFooter({ note }) {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <div className="footer-brand">Zpace Studio</div>
          <p className="footer-note">{note}</p>
        </div>
        <div className="footer-links">
          <Link to="/">Home</Link>
          <a href="https://edgezpace.com/">Edgezpace</a>
          <a href="https://accounts.zpacestudio.com/">Dashboard</a>
          <Link to="/about/">About</Link>
          <Link to="/privacy/">Privacy</Link>
          <Link to="/about/#contact">Contact</Link>
        </div>
      </div>
    </footer>
  )
}
